import { render, staticRenderFns } from "./WorkHistoryForm.vue?vue&type=template&id=2d9d271a&scoped=true&"
import script from "./WorkHistoryForm.vue?vue&type=script&lang=js&"
export * from "./WorkHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkHistoryForm.vue?vue&type=style&index=0&id=2d9d271a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d271a",
  null
  
)

export default component.exports